import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AITripDataService } from '../ai-trip-data.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-ai-trip-first',
  templateUrl: './ai-trip-first.component.html',
  styleUrls: ['./ai-trip-first.component.css']
})
export class AiTripFirstComponent implements OnInit {
  pilgrimForm: FormGroup;
  formSubmitted = false;

  searchCity: string = '';
  filteredCities: string[] = [];
  selectedCities: string[] = [];
  destinations = [];
  minDate: string;
  minStartDate: any;
  minEndDate: any;
  endDateBeforeStartDate: boolean = true;

  datePickerConfig: Partial<BsDatepickerConfig>;

  constructor(private router: Router, private fb: FormBuilder,
    private aitripDataService: AITripDataService, private meta: Meta, private title: Title) {
  }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
    this.datePickerConfig = {
      containerClass: 'theme-dark-blue',
      dateInputFormat: 'MMM DD, YYYY',
      showWeekNumbers: false,
    };

    this.pilgrimForm = this.fb.group({
      destination: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    });
    // Expose references globally for jQuery
    // for places remove from list 
    const existing = this.pilgrimForm.get('destination')?.value || '';
    this.selectedCities = existing ? existing.split(',').map(c => c.trim()) : [];


    this.minStartDate = new Date();
    this.minEndDate = this.minStartDate;
  }
  metaTagAdd() {
    this.title.setTitle('AI Powered Trip Planner | My Yatra 360');

    this.meta.updateTag({
      name: 'description',
      content: 'Let our smart AI assistant craft your perfect travel itinerary — from hidden gems to top attractions. Plan your dream trip effortlessly with My Yatra 360.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'AI Trip Planner Pilgrimage Tours'
    });
  }
  //#region Cities

  // Filter dropdown based on input
  filterCities() {
    const search = this.searchCity.toLowerCase();
    this.filteredCities = this.destinations
      .filter(city => city.toLowerCase().includes(search))
      .filter(city => !this.selectedCities.includes(city)); // exclude already selected
  }

  // Select city from dropdown
  selectCity(city: string) {
    if (!this.selectedCities.includes(city)) {
      this.selectedCities.push(city);
      this.pilgrimForm.patchValue({
        destination: this.selectedCities.join(', ')
      });
    }

    this.searchCity = '';
    this.filteredCities = [];
  }
  addTypedCity(val) {
    const trimmed = val.target.value;
    if (trimmed && !this.selectedCities.includes(trimmed)) {
      this.selectedCities.push(trimmed);
      this.updateFormValue();
    }
    this.searchCity = '';
    val.target.value = ''
    this.filteredCities = [];
  }
  // Remove selected city
  removeCity(city: string) {
    this.selectedCities = this.selectedCities.filter(c => c !== city);
    this.updateFormValue();
  }

  updateFormValue() {
    this.pilgrimForm.patchValue({
      destination: this.selectedCities.join(', ')
    });
  }

  //#endregion
  onCityChange(event: Event) {
    const place = (event.target as HTMLSelectElement).value;
    const destnt = place.trim();
    if (!destnt) return;

    const currentDest = this.pilgrimForm.get('destination')?.value || '';

    const destinations = currentDest
      .split(',')
      .map(d => d.trim())
      .filter(d => d); // remove empty strings

    // Add only if not already in the list
    if (!destinations.includes(destnt)) {
      destinations.push(destnt);
      this.pilgrimForm.patchValue({
        destination: destinations.join(', ')
      });
    }
  }

  onStartDateChange(date: any) {
    this.pilgrimForm.get('startDate')?.setValue(date);
    const startDate = this.pilgrimForm.get('startDate')?.value;
    if (startDate) {
      this.minEndDate = startDate;
      this.endDateBeforeStartDate = true;
    } else {
      this.endDateBeforeStartDate = false;
      this.pilgrimForm.get('endDate')?.setValue(null);
    }
  }

  onEndDateChange(date: any) {
    this.pilgrimForm.get('endDate')?.setValue(date);
    const startDate = this.pilgrimForm.get('startDate')?.value;
    const endDate = this.pilgrimForm.get('endDate')?.value;

    if (startDate) {
      this.endDateBeforeStartDate = true;
    } else {
      this.endDateBeforeStartDate = false;
      this.pilgrimForm.get('endDate')?.setValue(null);
    }
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.pilgrimForm.valid) {
      const startRaw = this.pilgrimForm.get('startDate')?.value;
      const endRaw = this.pilgrimForm.get('endDate')?.value;

      const startDate = new Date(startRaw);
      const endDate = new Date(endRaw);

      this.pilgrimForm.patchValue({
        startDate,
        endDate
      });

      this.aitripDataService.setTripData(this.pilgrimForm.value);
      this.router.navigate(['ai-trip-second']);
    }
  }
}
